import moment from 'moment';
import { Tooltip } from 'antd';
import React from 'react';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import PlatformIconRender from '../../../Common/PlatformIconRender';

const CampaignTargetsComponent = ({
  age,
  gender,
  influencerlistid,
  influencersource,
  language,
  location,
  topics,
}) => {
  return (
    <div className="row campaign_details_base">
      <div className="col-md-3">
        <p>Age</p>
        <h6>{`${age}` || 'n/a'}</h6>
      </div>
      <div className="col-md-2">
        <p>Gender</p>
        <h6>{`${gender}` || 'n/a'}</h6>
      </div>
      <div className="col-md-4">
        <p>Selected List ID</p>
        <h6 style={{ wordBreak: 'break-all' }}>{influencerlistid}</h6>
      </div>
      <div className="col-md-3">
        <p>Source</p>
        <h6 style={{ wordBreak: 'break-all' }}>{`${influencersource}`}</h6>
      </div>
      <div className="col-md-3">
        <p>Languages</p>
        <h6 style={{ wordBreak: 'break-all' }}>{`${language.length ? language : 'N/A'}`}</h6>
      </div>
      <div className="col-md-2">
        <p>Location</p>
        <h6 style={{ wordBreak: 'break-all' }}>{`${location.length ? location : 'N/A'}`}</h6>
      </div>
      <div className="col-md-3">
        <p>Selected Topics</p>
        <h6 style={{ wordBreak: 'break-all' }}>{`${topics.length ? topics : 'N/A'}`}</h6>
      </div>
    </div>
  );
};

export default CampaignTargetsComponent;
